export const VISIBLE_COMPANY_HEADERS = 2;
export const VISIBLE_COMPANY_MEMBER_HEADERS = 2;

export const COMPANY_HEADERS = [
  'Company Name',
  'Domains',
  'Status',
  'Members',
  'Updated',
  '',
];

export const COMPANY_MEMBER_HEADERS = [
  'Name',
  'Status',
  'Sessions',
  'Coach',
  'Contract End',
  'Seat Type',
  'Joined',
  'Growth Plan Started',
  'Insights Status',
  'Admin Note',
];

export const OPS_COMPANY_MEMBER_HEADERS = COMPANY_MEMBER_HEADERS.flatMap(
  (header) =>
    header === 'Contract End'
      ? [header, 'End Date Status', 'Cohort']
      : [header],
);

export const PARTNER_COMPANY_MEMBER_HEADERS = COMPANY_MEMBER_HEADERS.filter(
  (header) => header !== 'Coach',
);
